import { IDeleteClienteArquivoUseCase } from "../../../presentation/useCases/delete/delete_cliente_arquivo_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DeleteClienteArquivoUseCase
 */

export class DeleteClienteArquivoUseCase implements IDeleteClienteArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idClienteArquivo: number): Promise<void> {
    return this.repository.deleteClienteArquivoById(idClienteArquivo);

  }
}
